module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_500000-6ceabf08d2b444a26187cdf9072c7438.png";